export default __webpack_public_path__ + "static/media/Ajam-nirvikalpam.a3d6f18a.ogg";